(function() {
  const API_URL = 'https://superagent-befeaff5.base44.app/functions/browseApparelCatalog';
  const QUOTE_URL = 'https://superagent-befeaff5.base44.app/functions/submitApparelQuote';
  
  const container = document.getElementById('rbc-apparel-catalog');
  if (!container) return;

  // State
  let state = {
    view: 'types',
    type: null,
    brand: null,
    decoration: 'embroidery',
    styleId: null,
    selectedColor: null,
    page: 1,
    categories: null,
    styles: null,
    detail: null,
    loading: false,
    error: null,
    // Quote cart
    cart: [],
    cartOpen: false,
    // Quote form
    showQuoteForm: false,
    quoteSubmitted: false,
    quoteResult: null,
    // Size selector
    sizeQtys: {},
    placement: 'front',
  };

  async function apiFetch(params) {
    try {
      state.loading = true;
      state.error = null;
      render();
      const resp = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
      });
      const data = await resp.json();
      state.loading = false;
      if (data.error) { state.error = data.error; }
      return data;
    } catch (e) {
      state.loading = false;
      state.error = 'Failed to load catalog. Please try again.';
      render();
      return null;
    }
  }

  async function loadCategories() {
    const data = await apiFetch({ action: 'categories' });
    if (data) state.categories = data;
    render();
  }

  async function browseType(type) {
    state.view = 'styles';
    state.type = type;
    state.page = 1;
    const data = await apiFetch({ action: 'styles', type, brand: state.brand || '', decoration: state.decoration, limit: 12, page: 1 });
    if (data) state.styles = data;
    render();
  }

  async function loadPage(p) {
    state.page = p;
    const data = await apiFetch({ action: 'styles', type: state.type, brand: state.brand || '', decoration: state.decoration, limit: 12, page: p });
    if (data) state.styles = data;
    render();
  }

  async function viewDetail(styleId) {
    state.view = 'detail';
    state.styleId = styleId;
    state.selectedColor = null;
    state.sizeQtys = {};
    state.placement = 'front';
    const data = await apiFetch({ action: 'style-detail', styleId: String(styleId), decoration: state.decoration });
    if (data) {
      state.detail = data;
      if (data.colors && data.colors.length > 0) state.selectedColor = data.colors[0].colorName;
    }
    render();
  }

  function goBack() {
    if (state.view === 'detail') { state.view = 'styles'; state.detail = null; state.sizeQtys = {}; }
    else if (state.view === 'styles') { state.view = 'types'; state.styles = null; state.brand = null; }
    else if (state.view === 'quote-form') { state.view = 'types'; state.showQuoteForm = false; }
    render();
  }

  function selectColor(name) {
    state.selectedColor = name;
    state.sizeQtys = {};
    render();
  }

  function setDecoration(d) {
    state.decoration = d;
    if (state.view === 'detail' && state.styleId) viewDetail(state.styleId);
    else render();
  }

  function setBrand(b) {
    state.brand = b || null;
    if (state.view === 'styles') browseType(state.type);
  }

  function setPlacement(p) {
    state.placement = p;
    render();
  }

  function setSizeQty(size, qty) {
    qty = parseInt(qty) || 0;
    if (qty <= 0) { delete state.sizeQtys[size]; }
    else { state.sizeQtys[size] = qty; }
    render();
  }

  function addToQuote() {
    const d = state.detail;
    if (!d || !state.selectedColor) return;
    const selColor = d.colors.find(c => c.colorName === state.selectedColor);
    if (!selColor) return;
    
    const sizes = Object.entries(state.sizeQtys).filter(([s, q]) => q > 0);
    if (sizes.length === 0) { state.error = 'Please select at least one size and quantity.'; render(); return; }

    const decoLabel = state.decoration === 'embroidery' ? 'Embroidery' : 
                      state.decoration === 'dtf-transfer' ? 'DTF Transfer' :
                      state.decoration === 'screen-print' ? 'Screen Print' : 'Vinyl';
    const placementLabel = state.placement.charAt(0).toUpperCase() + state.placement.slice(1);

    const item = {
      id: Date.now(),
      brand: d.brand,
      styleName: d.styleName,
      title: d.title || d.brand + ' ' + d.styleName,
      color: state.selectedColor,
      colorHex: selColor.colorHex || '#ccc',
      image: selColor.frontImage || '',
      decoration: decoLabel,
      decorationId: state.decoration,
      placement: placementLabel,
      sizes: sizes.map(([size, qty]) => {
        const sizeData = selColor.sizes.find(s => s.size === size);
        return { size, qty, price: sizeData ? sizeData.retailPrice : 0 };
      }),
      totalQty: sizes.reduce((sum, [s, q]) => sum + q, 0),
    };
    
    state.cart.push(item);
    state.sizeQtys = {};
    state.error = null;
    state.cartOpen = true;
    
    // Go back to browse more
    state.view = 'styles';
    state.detail = null;
    render();
  }

  function removeFromCart(id) {
    state.cart = state.cart.filter(item => item.id !== id);
    render();
  }

  function toggleCart() {
    state.cartOpen = !state.cartOpen;
    render();
  }

  function showQuoteForm() {
    state.view = 'quote-form';
    state.showQuoteForm = true;
    render();
  }

  async function submitQuote() {
    const name = document.getElementById('rbc-quote-name')?.value?.trim();
    const email = document.getElementById('rbc-quote-email')?.value?.trim();
    const phone = document.getElementById('rbc-quote-phone')?.value?.trim();
    const company = document.getElementById('rbc-quote-company')?.value?.trim();
    const notes = document.getElementById('rbc-quote-notes')?.value?.trim();

    if (!name || !email) {
      state.error = 'Please provide your name and email address.';
      render();
      return;
    }

    state.loading = true;
    state.error = null;
    render();

    try {
      const resp = await fetch(QUOTE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer: { name, email, phone, company },
          items: state.cart.map(item => ({
            brand: item.brand,
            styleName: item.styleName,
            title: item.title,
            color: item.color,
            decoration: item.decoration,
            decorationId: item.decorationId,
            placement: item.placement,
            sizes: item.sizes,
            totalQty: item.totalQty,
          })),
          notes,
        }),
      });
      const data = await resp.json();
      state.loading = false;
      if (data.success) {
        state.quoteSubmitted = true;
        state.quoteResult = data;
        state.view = 'confirmation';
      } else {
        state.error = data.error || 'Failed to submit quote. Please try again.';
      }
    } catch (e) {
      state.loading = false;
      state.error = 'Failed to submit quote. Please try again.';
    }
    render();
  }

  // ── Render ──

  function render() {
    const cats = state.categories;
    let html = '';
    const cartCount = state.cart.reduce((sum, item) => sum + item.totalQty, 0);

    // Floating cart button
    if (state.cart.length > 0 && state.view !== 'quote-form' && state.view !== 'confirmation') {
      html += `<div class="rbc-cart-float" onclick="window._rbcToggleCart()">`;
      html += `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`;
      html += `<span class="rbc-cart-count">${cartCount} item${cartCount !== 1 ? 's' : ''}</span>`;
      html += `<span class="rbc-cart-label">Quote Cart</span>`;
      html += `</div>`;
    }

    // Cart drawer
    if (state.cartOpen && state.cart.length > 0 && state.view !== 'quote-form') {
      html += '<div class="rbc-cart-backdrop" onclick="window._rbcToggleCart()"></div>';
      html += '<div class="rbc-cart-drawer">';
      html += '<div class="rbc-cart-header">';
      html += `<h4>Quote Cart (${cartCount} items)</h4>`;
      html += `<button class="rbc-cart-close" onclick="window._rbcToggleCart()">&times;</button>`;
      html += '</div>';
      html += '<div class="rbc-cart-items">';
      state.cart.forEach(item => {
        html += '<div class="rbc-cart-item">';
        if (item.image) html += `<img src="${item.image}" alt="${item.title}" class="rbc-cart-thumb" />`;
        html += '<div class="rbc-cart-item-info">';
        html += `<strong>${item.brand} ${item.styleName}</strong>`;
        html += `<span>${item.color} · ${item.decoration} · ${item.placement}</span>`;
        html += `<span>${item.sizes.map(s => `${s.size}×${s.qty}`).join(', ')}</span>`;
        html += `<span class="rbc-cart-item-qty">${item.totalQty} units</span>`;
        html += '</div>';
        html += `<button class="rbc-cart-remove" onclick="window._rbcRemoveFromCart(${item.id})">&times;</button>`;
        html += '</div>';
      });
      html += '</div>';
      html += `<button class="rbc-quote-btn" onclick="window._rbcShowQuoteForm()">Request Quote →</button>`;
      html += '</div>';
    }

    // Loading
    if (state.loading) {
      html += '<div class="rbc-loading"><div class="rbc-spinner"></div></div>';
    }
    if (state.error) {
      html += `<div class="rbc-error">${state.error}</div>`;
    }

    // TYPES VIEW
    if (state.view === 'types' && cats) {
      html += '<div class="rbc-header">';
      html += '<h3>Custom Apparel Catalog</h3>';
      html += '<p>Pick your garments, choose your decoration method and placement, then request a quote. We\'ll respond with pricing and a payment link within minutes.</p>';
      html += '</div>';

      // Decoration selector
      html += '<div class="rbc-deco-bar">';
      html += '<label>Decoration method:</label>';
      const decoOptions = [
        { id: 'embroidery', label: 'Embroidery', price: 12 },
        { id: 'dtf-transfer', label: 'DTF Transfer', price: 5 },
        { id: 'screen-print', label: 'Screen Print', price: 12 },
        { id: 'vinyl', label: 'Vinyl', price: 10 },
      ];
      decoOptions.forEach(d => {
        const active = state.decoration === d.id ? 'active' : '';
        html += `<button class="rbc-deco-btn ${active}" onclick="window._rbcSetDeco('${d.id}')">${d.label}</button>`;
      });
      html += '</div>';

      // Type grid
      html += '<div class="rbc-type-grid">';
      const typeIcons = {
        't-shirts': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 3l4 4-3 1v12H7V8L4 7l4-4c1 1.5 3 2 4 2s3-.5 4-2z"/></svg>',
        'long-sleeves': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 3l5 5-4 1v11H7V9L3 8l5-5c1 1.5 3 2 4 2s3-.5 4-2z"/></svg>',
        'polos': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 3l4 4-3 1v12H7V8L4 7l4-4c1 1.5 3 2 4 2s3-.5 4-2z"/><path d="M10 3v3M14 3v3"/></svg>',
        'hoodies': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 3l4 5-3 1v11H7V9L3 8l4-5c1 1 2 2 5 2s4-1 5-2z"/><path d="M9 3c0 2 1.5 3 3 3s3-1 3-3"/></svg>',
        'crewnecks': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 4l3 3-2 1v12H7V8L5 7l3-3c1 1 3 1.5 4 1.5S15 5 16 4z"/></svg>',
        'quarter-zips': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 3l4 5-3 1v11H7V9L3 8l4-5c1 1.5 3 2 4 2s3-.5 4-2z"/><line x1="12" y1="5" x2="12" y2="12"/></svg>',
        'tanks': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3h8v1l2 3v13H6V7l2-3V3z"/></svg>',
        'jackets': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 3l5 5-4 2v10H7V10L3 8l5-5c1 1.5 3 2 4 2s3-.5 4-2z"/><line x1="12" y1="5" x2="12" y2="20"/></svg>',
        'hats': '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 14c0-4 3.5-8 8-8s8 4 8 8"/><path d="M2 14h20"/><path d="M6 14v2"/></svg>',
      };
      (cats.apparelTypes || []).forEach(t => {
        const icon = typeIcons[t.id] || typeIcons['t-shirts'];
        html += `<button class="rbc-type-card" onclick="window._rbcBrowseType('${t.id}')">`;
        html += `<span class="rbc-type-icon">${icon}</span>`;
        html += `<span class="rbc-type-label">${t.label}</span>`;
        html += '</button>';
      });
      html += '</div>';
    }

    // STYLES VIEW
    if (state.view === 'styles' && state.styles) {
      const s = state.styles;
      html += '<div class="rbc-header">';
      html += `<button class="rbc-back" onclick="window._rbcGoBack()">← Back</button>`;
      html += `<h3>${s.type ? s.type.split('-').map(w=>w[0].toUpperCase()+w.slice(1)).join(' ') : ''}</h3>`;
      html += `<span class="rbc-count">${s.total} styles</span>`;
      html += '</div>';

      if (cats) {
        html += '<div class="rbc-brand-bar">';
        html += `<button class="rbc-brand-btn ${!state.brand ? 'active' : ''}" onclick="window._rbcSetBrand('')">All Brands</button>`;
        (cats.brands || []).forEach(b => {
          const active = state.brand === b.name ? 'active' : '';
          html += `<button class="rbc-brand-btn ${active}" onclick="window._rbcSetBrand('${b.name}')">${b.name}</button>`;
        });
        html += '</div>';
      }

      html += '<div class="rbc-style-grid">';
      (s.styles || []).forEach(st => {
        html += `<button class="rbc-style-card" onclick="window._rbcViewDetail(${st.styleId})">`;
        if (st.image) html += `<img src="${st.image}" alt="${st.title}" loading="lazy" />`;
        html += `<div class="rbc-style-info">`;
        html += `<span class="rbc-style-brand">${st.brand}</span>`;
        html += `<span class="rbc-style-name">${st.title}</span>`;
        html += `<span class="rbc-style-sku">${st.styleName}</span>`;
        html += '</div></button>';
      });
      html += '</div>';

      if (s.totalPages > 1) {
        html += '<div class="rbc-pagination">';
        for (let i = 1; i <= Math.min(s.totalPages, 10); i++) {
          const active = i === s.page ? 'active' : '';
          html += `<button class="rbc-page-btn ${active}" onclick="window._rbcLoadPage(${i})">${i}</button>`;
        }
        if (s.totalPages > 10) html += `<span>... ${s.totalPages} pages</span>`;
        html += '</div>';
      }
    }

    // DETAIL VIEW (with size quantity picker + placement + add to quote)
    if (state.view === 'detail' && state.detail) {
      const d = state.detail;
      const selColor = d.colors.find(c => c.colorName === state.selectedColor) || d.colors[0];

      html += '<div class="rbc-header">';
      html += `<button class="rbc-back" onclick="window._rbcGoBack()">← Back to styles</button>`;
      html += '</div>';

      html += '<div class="rbc-detail-layout">';

      // Image
      html += '<div class="rbc-detail-image">';
      if (selColor && selColor.frontImage) {
        html += `<img src="${selColor.frontImage}" alt="${selColor.colorName}" />`;
      }
      html += '</div>';

      // Info
      html += '<div class="rbc-detail-info">';
      html += `<span class="rbc-detail-brand">${d.brand}</span>`;
      html += `<h3 class="rbc-detail-title">${d.title || d.brand + ' ' + d.styleName}</h3>`;
      html += `<span class="rbc-detail-sku">Style: ${d.styleName}</span>`;

      // Price display
      if (d.pricing && d.pricing.retailPrice) {
        html += `<div class="rbc-detail-price">From <strong>$${d.pricing.retailPrice.toFixed(2)}</strong> per shirt <span class="rbc-price-note">(includes ${d.decoration.label.toLowerCase()})</span></div>`;
      }

      // Decoration selector
      html += '<div class="rbc-deco-bar compact">';
      html += '<label>Decoration:</label>';
      const decoOpts = [
        { id: 'embroidery', label: 'Embroidery' },
        { id: 'dtf-transfer', label: 'DTF Transfer' },
        { id: 'screen-print', label: 'Screen Print' },
        { id: 'vinyl', label: 'Vinyl' },
      ];
      decoOpts.forEach(dec => {
        const active = state.decoration === dec.id ? 'active' : '';
        html += `<button class="rbc-deco-btn ${active}" onclick="window._rbcSetDeco('${dec.id}')">${dec.label}</button>`;
      });
      html += '</div>';

      // Placement selector
      html += '<div class="rbc-placement-bar">';
      html += '<label>Design placement:</label>';
      const placements = ['front', 'back', 'left-chest', 'right-chest', 'sleeve', 'pocket'];
      placements.forEach(p => {
        const active = state.placement === p ? 'active' : '';
        const label = p.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
        html += `<button class="rbc-placement-btn ${active}" onclick="window._rbcSetPlacement('${p}')">${label}</button>`;
      });
      html += '</div>';

      // Color swatches
      html += '<div class="rbc-colors-section">';
      html += `<label>Color: <strong>${state.selectedColor || ''}</strong> (${d.totalColors} available)</label>`;
      html += '<div class="rbc-color-swatches">';
      d.colors.forEach(c => {
        const active = c.colorName === state.selectedColor ? 'active' : '';
        const bg = c.colorHex || '#ccc';
        html += `<button class="rbc-swatch ${active}" style="background-color:${bg}" title="${c.colorName}" onclick="window._rbcSelectColor('${c.colorName.replace(/'/g,"\\'")}')"></button>`;
      });
      html += '</div></div>';

      // Size quantity picker
      if (selColor) {
        html += '<div class="rbc-sizes-section">';
        html += '<label>Select sizes and quantities:</label>';
        html += '<div class="rbc-size-qty-grid">';
        selColor.sizes.forEach(sz => {
          if (!sz.inStock) return;
          const qty = state.sizeQtys[sz.size] || 0;
          html += '<div class="rbc-size-qty-row">';
          html += `<span class="rbc-size-label">${sz.size}</span><span class="rbc-size-price">$${sz.retailPrice.toFixed(2)}</span>`;
          html += '<div class="rbc-qty-control">';
          html += `<button type="button" class="rbc-qty-btn" onclick="window._rbcSetSizeQty('${sz.size}', ${Math.max(0, qty - 1)})">−</button>`;
          html += `<input type="number" class="rbc-qty-input" value="${qty}" min="0" oninput="window._rbcSetSizeQty('${sz.size}', this.value)" />`;
          html += `<button type="button" class="rbc-qty-btn" onclick="window._rbcSetSizeQty('${sz.size}', ${qty + 1})">+</button>`;
          html += '</div>';
          html += '</div>';
        });
        html += '</div></div>';

        // Selected count
        const totalSelected = Object.values(state.sizeQtys).reduce((a, b) => a + b, 0);
        if (totalSelected > 0) {
          html += '<div class="rbc-selection-summary">';
          html += `<strong>${totalSelected} shirt${totalSelected !== 1 ? 's' : ''}</strong> selected`;
          html += '</div>';
        }

        // Add to quote button
        html += '<div class="rbc-add-to-quote">';
        html += `<button class="rbc-add-btn" onclick="window._rbcAddToQuote()" ${totalSelected === 0 ? 'disabled' : ''}>`;
        html += `Add to Quote${totalSelected > 0 ? ' (' + totalSelected + ')' : ''}`;
        html += '</button>';
        html += '</div>';
      }

      html += '</div></div>';
    }

    // QUOTE FORM VIEW
    if (state.view === 'quote-form') {
      html += '<div class="rbc-quote-form-view">';
      html += '<div class="rbc-header">';
      html += `<button class="rbc-back" onclick="window._rbcGoBack()">← Back to catalog</button>`;
      html += '<h3>Request Your Quote</h3>';
      html += '</div>';

      // Order summary
      html += '<div class="rbc-order-summary">';
      html += '<h4>Order Summary</h4>';
      state.cart.forEach((item, i) => {
        html += '<div class="rbc-summary-item">';
        if (item.image) html += `<img src="${item.image}" class="rbc-summary-thumb" />`;
        html += '<div class="rbc-summary-details">';
        html += `<strong>${item.brand} ${item.styleName}</strong>`;
        html += `<span>${item.color} · ${item.decoration} · ${item.placement}</span>`;
        html += `<span>${item.sizes.map(s => s.size + ' × ' + s.qty).join(', ')}</span>`;
        html += `<span class="rbc-summary-qty">${item.totalQty} units</span>`;
        html += '</div>';
        html += `<button class="rbc-cart-remove" onclick="window._rbcRemoveFromCart(${item.id})">&times;</button>`;
        html += '</div>';
      });
      const totalUnits = state.cart.reduce((sum, item) => sum + item.totalQty, 0);
      html += `<div class="rbc-summary-total"><strong>Total: ${totalUnits} garments</strong></div>`;
      html += '</div>';

      // Contact form
      html += '<div class="rbc-contact-form">';
      html += '<h4>Your Information</h4>';
      html += '<div class="rbc-form-row"><label>Name *</label><input type="text" id="rbc-quote-name" placeholder="Your full name" required /></div>';
      html += '<div class="rbc-form-row"><label>Email *</label><input type="email" id="rbc-quote-email" placeholder="you@company.com" required /></div>';
      html += '<div class="rbc-form-row"><label>Phone</label><input type="tel" id="rbc-quote-phone" placeholder="(555) 555-5555" /></div>';
      html += '<div class="rbc-form-row"><label>Company</label><input type="text" id="rbc-quote-company" placeholder="Company name" /></div>';
      html += '<div class="rbc-form-row"><label>Design notes</label><textarea id="rbc-quote-notes" rows="3" placeholder="Logo details, special instructions, rush timeline, etc."></textarea></div>';
      html += '<p class="rbc-form-note">Upload your design file(s) above using the "Upload Your Design" button, or email them to orders@revivalbrandco.com after submitting.</p>';
      html += `<button class="rbc-submit-btn" onclick="window._rbcSubmitQuote()">Submit Quote Request</button>`;
      html += '</div>';
      html += '</div>';
    }

    // CONFIRMATION VIEW
    if (state.view === 'confirmation') {
      html += '<div class="rbc-confirmation">';
      html += '<div class="rbc-confirm-icon">✓</div>';
      html += '<h3>Quote Request Submitted!</h3>';
      html += '<p>We\'ve received your custom apparel order. You\'ll receive a detailed quote with pricing and a payment link to your email within minutes.</p>';
      html += '<p>Questions? Call us at <strong>(385) 626-7137</strong> or email <strong>orders@revivalbrandco.com</strong></p>';
      if (state.quoteResult && state.quoteResult.projectId) {
        html += `<p class="rbc-ref">Reference: #${state.quoteResult.projectId}</p>`;
      }
      html += '</div>';
    }

    container.innerHTML = html;
  }

  // Global handlers
  window._rbcBrowseType = browseType;
  window._rbcGoBack = goBack;
  window._rbcSelectColor = selectColor;
  window._rbcSetDeco = setDecoration;
  window._rbcSetBrand = setBrand;
  window._rbcViewDetail = viewDetail;
  window._rbcLoadPage = loadPage;
  window._rbcToggleCart = toggleCart;
  window._rbcRemoveFromCart = removeFromCart;
  window._rbcShowQuoteForm = showQuoteForm;
  window._rbcSubmitQuote = submitQuote;
  window._rbcAddToQuote = addToQuote;
  window._rbcSetSizeQty = setSizeQty;
  window._rbcSetPlacement = setPlacement;

  loadCategories();
})();



